<template>
    <mini-button :loading="queryLoading" @click="whenClick">
        查看外协序

        <re-b-modal ref="view" header="外协序查看" no-ok-button fit-content :loading="queryLoading">
            <mini-table read-only
                        need-model-fields
                        entity-name="sithMesPrdPpOperation"
                        custom-vuex-name="scheduling"
                        :items="list"
                        filterable>
            </mini-table>
        </re-b-modal>
    </mini-button>
</template>

<script>
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
    name: "OutOperationView",
    components: {MiniTable, ReBModal, MiniButton},
    data() {
        return {
            queryLoading: false,
            list: [],
        }
    },
    methods: {
        whenClick() {
            this.$refs.view.showModal();
            this.queryRemote();
        },
        queryRemote() {
            this.queryLoading = true;
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdPpOperation/outOperation/willStart"
            }).then(res => {
                this.list = res;
            }).finally(() => this.queryLoading = false);
        },
    }
}
</script>

<style scoped>

</style>
